import { render } from "./TicketIndex.vue?vue&type=template&id=dbe3bb64"
import script from "./TicketIndex.vue?vue&type=script&lang=js"
export * from "./TicketIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__